const reConfig = {
  sitekey: '6Lc4NCoaAAAAAAm1lLjEKLO0_hfKwdP10HUffl9h'
}
export default reConfig



// WEBPACK FOOTER //
// ./src/config/common/captcha.js